import React, { useState, useEffect } from "react";
import { Select, DatePicker } from "antd";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { RangePicker } = DatePicker;

const LogFilter = ({
  parentProps = {},
  onFilterChange = () => {},
  mode = "media",
}) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).activityLog;
  const [filters, setFilters] = useState({
    usage: [],
    expiry: [],
    dateRange: null, // Store selected date range
  });
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const [userDatas, setUserDatas] = useState([]);
  const [userloading, setUserLoading] = useState(false);

  const disabledDate = (current) => {
    if (!dates) {
      return false;
    }
    const tooLate = dates[0] && current.diff(dates[0], "days") > 7;
    const tooEarly = dates[1] && dates[1].diff(current, "days") > 7;
    return !!tooEarly || !!tooLate;
  };

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFilterChange(newFilters); // Notify parent
  };

  useEffect(() => {
    if (parentProps) {
      reloadUsers();
    }
  }, [parentProps]);

  const reloadUsers = () => {
    const { usermaintoken, requestServerGet, selectedBrandData } = parentProps;

    setUserLoading(true);

    requestServerGet(
      "get_users",
      {},
      null,
      (response) => {
        console.log(response.data);
        // const options = response.data.map(data => {
        //     return { value: data.CampaignID, label: data.CampaignName }
        // })

        const processedUsers = response.data.map((userData, index) => {
          return {
            id: userData.userid,
            username: userData.username,
            name: `${userData.firstname} ${userData.lastname}`,
            role: userData.userrolename,
            status: userData.activated,
          };
        });
        setUserDatas(processedUsers);
        setUserLoading(false);
        // options.unshift({ value: 0, label: "Create New Playlist" })
        // this.setState({ userRawDatas: response.data, users: processedUsers }, resolve)
        // this.setState({ campaigntDatas: options, campaignOptions: options })
      },
      usermaintoken,
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 16,
        alignItems: "flex-end",
      }}
    >
      {/* Date Range Filter */}
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        <label
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#64748b",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          {t.filterDateRange}{" "}
          <span style={{ fontSize: 10, fontWeight: 400, color: "#94a3b8" }}>
            {t.filterDateRangeMax}
          </span>
        </label>
        <RangePicker
          allowClear
          disabledDate={disabledDate}
          onCalendarChange={(val) => setDates(val)}
          size="middle"
          style={{ minWidth: 260, borderRadius: 8, height: 36 }}
          placeholder={[t.filterDateStart, t.filterDateEnd]}
          value={filters.dateRange}
          onChange={(dates) => handleFilterChange("dateRange", dates || null)}
        />
      </div>

      {/* User Filter */}
      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
        <label
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#64748b",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
          }}
        >
          {t.filterUsers}
        </label>
        <Select
          mode="multiple"
          style={{ minWidth: 200 }}
          placeholder={t.filterAllUsers}
          onChange={(value) => handleFilterChange("users", value)}
          allowClear
          optionFilterProp="children"
          loading={userloading}
          filterOption={(input, option) =>
            (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
          }
        >
          {userDatas.map((user) => (
            <Select.Option key={user.id} value={user.id}>
              {user.username}
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default LogFilter;
